import { render, staticRenderFns } from "./DatavMapVisitStats.vue?vue&type=template&id=b0c5af1a&"
import script from "./DatavMapVisitStats.vue?vue&type=script&lang=js&"
export * from "./DatavMapVisitStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DatavMapVisitStats.vue"
export default component.exports